import { SortDescriptor } from '@progress/kendo-data-query'
import {
  TransactionFilterKey,
  TransactionKey,
  TransactionSortKey,
} from 'api/Transaction/Types/Transaction'

export const normalizeTransactionsSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === TransactionKey.type) {
        return { ...x, field: TransactionFilterKey.type }
      }
      if (x.field === TransactionKey.reference) {
        return { ...x, field: TransactionFilterKey.reference }
      }
      if (x.field === TransactionKey.state) {
        return { ...x, field: TransactionFilterKey.state }
      }
      if (x.field === TransactionKey.date) {
        return { ...x, field: TransactionFilterKey.date }
      }
      if (x.field === TransactionKey.walletTransactionWallet) {
        return { ...x, field: TransactionFilterKey.walletTransactionWallet }
      }
      if (x.field === TransactionKey.walletTransactionWalletClient) {
        return { ...x, field: TransactionFilterKey.walletTransactionWalletClient }
      }
      if (x.field === TransactionKey.walletTransactionWalletCompany) {
        return { ...x, field: TransactionFilterKey.walletTransactionWalletCompany }
      }
      if (x.field === TransactionKey.walletTransactionPaymentProviderTransaction) {
        return { ...x, field: TransactionFilterKey.walletTransactionPaymentProviderTransaction }
      }

      if (x.field === TransactionKey.walletCreditTransactionWallet) {
        return { ...x, field: TransactionFilterKey.walletTransactionWallet }
      }
      if (x.field === TransactionKey.walletCreditTransactionWalletClient) {
        return { ...x, field: TransactionFilterKey.walletTransactionWalletClient }
      }
      if (x.field === TransactionKey.walletCreditTransactionWalletCompany) {
        return { ...x, field: TransactionFilterKey.walletTransactionWalletCompany }
      }

      if (x.field === TransactionKey.walletDebitTransactionWallet) {
        return { ...x, field: TransactionFilterKey.walletTransactionWallet }
      }
      if (x.field === TransactionKey.walletDebitTransactionWalletClient) {
        return { ...x, field: TransactionFilterKey.walletTransactionWalletClient }
      }
      if (x.field === TransactionKey.walletDebitTransactionWalletCompany) {
        return { ...x, field: TransactionFilterKey.walletTransactionWalletCompany }
      }

      if (x.field === TransactionKey.tradingAccountTransactionTradingAccount) {
        return { ...x, field: TransactionFilterKey.tradingAccountTransactionTradingAccount }
      }

      if (x.field === TransactionKey.createdDate) {
        return { ...x, field: TransactionSortKey.createdDate }
      }
      if (x.field === TransactionKey.updatedDate) {
        return { ...x, field: TransactionSortKey.updatedDate }
      }
      return x
    })
    .filter((x) => !!x)
